import { styled, StyledFlex, StyledImage } from '@raskrask-dk/rr-components'

export const StyledHeader = styled('div', {
    mt: 16,

    [`& ${StyledFlex}`]: {
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    [`& ${StyledImage}`]: {
        w: 150,
    },
})
